export function getFileSize(bytes) {
    if(isNaN(bytes)) return bytes;
    const thresh = 1000;
    if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    const units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
}

export function doDlFiles(url, filename){
    let link = document.createElement('a');
    link.download = filename;
    link.href = url;
    link.click();
}

export function str2Array(str){
    let array = [],i,il=str.length;
    for(i=0;i<il;i++) array.push(str.charCodeAt(i));
    return array;
}



// WEBPACK FOOTER //
// ./src/common/utils/files.js